<template>
  <div class="background">
    <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
      <div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="项目信息" name="first">
            <div>
              <el-col :span="12">
                <div>项目名称</div>
                <div>
                  <el-input v-model="inputName" placeholder="请输入项目名称"></el-input>
                </div>
              </el-col>
              <el-col :span="12">
                <div>内容描述</div>
                <div>
                  <el-input v-model="inputDec" placeholder="请输入内容描述"></el-input>
                </div>
              </el-col>
            </div>
            <div>
              上架起止时间
            </div>
            <div class="block">
              <el-date-picker
                  v-model="value1"
                  type="date"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
            <div>场馆地址</div>
            <div>
              <el-input v-model="inputAddress" placeholder="请输入场馆地址"></el-input>
            </div>
            <div>海报图</div>
            <div>
              <el-upload
                  action="https://dreamportal.nextscene.cn/api/cos/bucket/dreamportal/check"
                  list-type="picture-card"
                  :before-upload="beforeUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </div>

          </el-tab-pane>
          <el-tab-pane label="体验详情" name="second">
            <div>详情页顶图</div>
            <div>
              <el-upload
                  action="https://jsonplaceholder.typicode.com/posts/"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </div>
          </el-tab-pane>
          <el-tab-pane label="购票须知" name="third">
            <div>购票须知文案</div>
            <div>
              <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="textarea">
              </el-input>
            </div>
          </el-tab-pane>
        </el-tabs>

      </div>
      <div>
        <button @click="go">取消</button>
        <button @click="getCreateContent">新建</button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "createContent",
  data() {
    return {
      tableData: {},
      value: '',
      activeName: 'first',
      value1: '',
      inputName: '',
      inputDec: '',
      inputAddress: '',
      dialogImageUrl: '',
      dialogVisible: false,
      textarea: '',
      url: ''
    }
  },
  created() {

  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeUpload(file) {
      console.log(777, file)

      // 获取文件扩展名
      const fileName = file.name.substring(0, file.name.lastIndexOf('.'))
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1); // 获取扩展名
      console.log(335553, fileName)
      console.log(335556663, fileExtension)
      // 创建 FormData 实例，添加自定义参数
      var data = {
        "filename": fileName,
        "ext": fileExtension
      }

      // 手动调用上传函数
      this.uploadFile(data);

    },
    uploadFile(data) {
      console.log(333, data)

      $.ajax({
        url: this.$settings.BASE_URL + 'cos/bucket/dreamportal/check',
        type: 'POST',
        dataType: 'json',
        header: {
          'Content-Type': "application/x-www-form-urlencoded"
        },
        data: data,
        success: (res) => {
          if (res.info == 'ok') {
            this.url = res.url
          }
          console.log('获取到的数据555：', res)

        },
        error: (error) => {
          console.log('请求失败：', error)
        }
      })
    },
    go() {
      this.$router.push(`projectManagement`)
    },
    getCreateContent() {
      var selectedValue = localStorage.getItem('selectedValue');
      var inputName = this.inputName
      var inputDec = this.inputDec
      var inputAddress = this.inputAddress
      var value1 = this.value1
      const year = value1.getFullYear();
      // 获取月，需要注意月份是从0开始计数的，所以要加1
      const month = String(value1.getMonth() + 1).padStart(2, '0');
      // 获取日
      const day = String(value1.getDate()).padStart(2, '0');
      // 组合成指定格式的日期字符串
      var formattedDate = `${year}-${month}-${day}`;
      console.log('formattedDate：', formattedDate)
      var url = this.url
      console.log('inputName：', inputName)
      console.log('inputDec：', inputDec)
      console.log('inputAddress：', inputAddress)
      var data = {
        "name": inputName,
        "dec": inputDec,
        "time": formattedDate,
        "url": url,
        "address":inputAddress,
        "status":"已上架"
      }
      console.log('json_data：', data)
      $.ajax({
        url: this.$settings.BASE_URL + 'create/content/info',
        type: 'POST',
        dataType: 'json',
        data: {
          "site_id": selectedValue,
          "content_data": JSON.stringify(data),
          "password": "hotpoorinchina"
        },
        success: (res) => {
          console.log('获取到的数据：', res)
          if (res.info == 'ok') {
            this.$router.push(`projectManagement`)
          } else {
            alert(res.about)
          }
        },
        error: (error) => {
          console.log('请求失败：', error)

        }
      })
    }
  },
  mounted() {
    var ticketTypeId = this.$route.query.id;
    var that = this
    $.ajax({
      // url: 'https://dreamportal.nextscene.cn/api/ticket/info',
      url: 'http://127.0.0.1:8002/api/ticket/info',
      type: 'GET',
      dataType: 'json',
      success: (res) => {
        console.log('获取到的数据：', res)
        let tableData = {}
        if (res.info == 'ok') {
          res.orderList.forEach(function (ticketType) {
            const result = ticketType.name.match(/【([^】]+)】/);
            if (result && result.length > 1) {
              var ticket_type = result[1];
              console.log(ticket_type); // 输出：早鸟票
            }
            if (ticketType.id == ticketTypeId) {
              tableData = {
                id: ticketType.id,
                info: ticketType.name,
                category: '地球档案',
                price: ticketType.price,
                originalPrice: ticketType.originalPrice,
                max_num: ticketType.max_num,
                ticketType: ticket_type,
                status: ticketType.status
              }
              that.num = ticketType.max_num
            }

          })
          this.tableData = tableData
        }
      },
      error: (error) => {
        console.log('请求失败：', error)
      }
    })

  },
}
</script>

<style scoped>

.background {
  background-color: #F4F5FA;
}


</style>
